<template lang="pug">
    div.app-container
        //- 查询操作
        div.filter-container
            el-select(v-model="listQuery.activity_type" placeholder="选择引导留评方式" clearable).filter-item.ml-5
              el-option( v-for="item in type_options" :key="item.value" :label="item.label" :value="item.value")
            el-select(v-model="listQuery.tag" placeholder="按激活进度筛选" style="width:120px" clearable).filter-item.ml-5
              el-option( v-for="item in tags_options" :key="item.value" :label="item.label" :value="item.value")
                tag(:color="item.color" :value="item.value") 
            el-select(v-model="listQuery.rating" placeholder="按星级筛选" clearable style="width:110px").filter-item.ml-5
              el-option( v-for="item in rating_options" :key="item.value" :label="item.label" :value="item.value")
            el-select(v-model="listQuery.status" placeholder="按礼品发放进度" clearable style="width:150px").filter-item.ml-5
              el-option( v-for="item in order_status_options" :key="item.value" :label="item.label" :value="item.value")
            el-select(v-model="listQuery.store_name" placeholder="选择店铺" clearable style="width:120px").filter-item.ml-5
              el-option( v-for="item in storeOptions" :key="item.value" :label="item.label" :value="item.value")
            el-input(v-model="listQuery.keyword" clearable style="width: 150px;" placeholder="订单号/ASIN/邮箱").filter-item.ml-5
            el-date-picker(v-model="listQuery.date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期").filter-item.ml-5
            el-button(v-permission="['order:activity-order:list']" type="primary" icon="el-icon-search" @click="onFilter").filter-item.ml-5 查找
            el-button(v-permission="['order:activity-order:export']" type="primary" icon="el-icon-upload2" @click="onExport" :loading="downloadLoading").filter-item.float-right 导出Excel

        //- 查询结果 
        el-table(v-loading="listLoading" :data="list" size="small" element-loading-text="正在查询中。。。" border fit highlight-current-row)
            el-table-column(align="left" label="ASIN" prop="asin" sortable width="120px")
            el-table-column(align="left" label="SKU" prop="sku" width="120px")
            el-table-column(align="left" label="店铺名称" prop="store_name" width="120px")
            el-table-column(align="left" label="Amazon订单ID" prop="order_id" sortable width="180px")
              template(slot-scope="scope")
                el-link(@click="onViewAmazonOrder(scope.row)") {{scope.row.order_id}}
            el-table-column(align="right" label="最新提交时间" prop="last_tag_date" sortable width="140px")
                template(slot-scope="scope")
                    span {{scope.row.last_tag_date | formatDateAndTime}}
            el-table-column(align="left" label="购买时间" prop="purchase_date" sortable width="140px")
                template(slot-scope="scope")
                    span {{scope.row.purchase_date | formatDateAndTime}}
            el-table-column(align="left" label="状态" prop="status" sortable width="140px")
                template(slot-scope="scope")
                    span {{translateOrderStatus(scope.row.status)}}
            el-table-column(align="right" label="邮箱" prop="email" width="140px")
            el-table-column(align="right" label="客户确认留评" width="140px")
                template(slot-scope="scope")
                    span {{scope.row.comment_confirmed ? "是" : "否"}}
            el-table-column(align="right" label="激活进度" prop="tags" width="140px")
                template(slot-scope="scope")
                    tags(:tags="scope.row.tags")
            el-table-column(align="right" label="核实留评" )
                template(slot-scope="scope")
                    span {{scope.row.comment_validated ? "是" : "否"}}
            el-table-column(align="right" label="评价星级" prop="rating" )

            el-table-column(align="center" label="操作" min-width="140px").small-padding.fixed-width
                template(slot-scope="scope")
                    el-link(v-permission="['order:activity-order:view']" type="primary" size="mini" @click="onView(scope.row)") 详情
                    el-link.opt-link(v-permission="['order:activity-order:edit']" type="primary" size="mini" @click="onUpdate(scope.row)") 编辑
                    el-link.opt-link(v-permission="['order:activity-order:delete']" type="primary" size="mini" @click="onDelete(scope.row)") 删除

        //- 分页
        pagination(v-show="total>0" :total="total"  :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList")

        //- 弹出层 - 修改订单
        el-dialog(:visible.sync="dialogForm" title="邀评活动激活订单" :close-on-click-modal="false").pupup-form.tab
          el-tabs(v-model="activeTab")
            el-tab-pane(label="表单信息" name="form")
              el-form(:inline="true" :model="form" label-width="130px" ref="form" :rules="formRules" )
                el-form-item(label="Amazon订单ID")
                  el-input(v-model="form.order_id" readonly)
                el-form-item(label="店铺名称")
                  el-input(v-model="form.store_name" readonly)
                el-form-item(label="ASIN")
                  el-input(v-model="form.asin" readonly)
                el-form-item(label="SKU")
                  el-input(v-model="form.sku" readonly)
                el-form-item(label="激活时间")
                  el-input(:value="formatDateAndTime(form.active_date)" readonly)
                el-form-item(label="邀评类型")
                  el-input(v-model="form.activity_type" readonly)
                el-form-item(label="评论星级")
                  el-input(v-model="form.rating" readonly)
                el-form-item(label="活动名称")
                  el-input(v-model="form.activity_name" readonly)
                el-form-item(label="评论内容")
                  el-input(v-model="form.comment" readonly)
                el-form-item(label="邮箱" )
                  el-input(v-model="form.email" readonly)
                el-form-item(label="姓名")
                  el-input(v-model="form.name" readonly)
                el-form-item(label="购买价格")
                  el-input(v-model="form.item_price_per_unit" readonly)
                    template(slot="prepend") $
                el-form-item(label="Giftcard邮箱" )
                  el-input(v-model="form.gift_email" readonly)
                el-form-item(label="Paypal Account")
                  el-input(v-model="form.paypal_account" readonly)
                el-form-item(label="Paypal Holder")
                  el-input(v-model="form.paypal_holder" readonly)
                el-form-item(label="状态")
                  el-select(v-model="form.status" :disabled="formMode!='edit'" placeholder="按礼品发放进度" clearable).filter-item.ml-5
                    el-option( v-for="item in order_status_options" :key="item.value" :label="item.label" :value="item.value")
                el-form-item(label="礼品收件人")
                  el-input(v-model="form.full_name" readonly)
                el-form-item(label="礼品快递单号" v-if="form.status=='SHIPPED'" prop="tracking_no" )
                  el-input(v-model="form.tracking_no" placeholder="礼品快递单号/Giftcard序列号" :readonly="formMode!='edit'" )
                el-form-item(label="礼品发送时间" v-if="form.status=='SHIPPED'" prop="shipment_date" )
                  el-date-picker(v-model="form.shipment_date" type="date" placeholder="选择日期" :readonly="formMode!='edit'")
                el-form-item(label="地址")
                  el-input(type="textarea" v-model="form.address" readonly)
                el-form-item(label="客户留评确认")
                  el-input(:value="form.comment_confirmed?'是':'否'" readonly)
                el-form-item(label="留评核实")
                  el-select(v-model="form.comment_validated"  :disabled="formMode!='edit'" placeholder="请选择").filter-item.ml-5
                    el-option( v-for="item in boolean_options" :key="item.value" :label="item.label" :value="item.value")
                el-form-item(label="操作人")
                  el-input(:value="lastUpdateBy" readonly)
                el-form-item(label="评论截图" prop="comment_img" v-if="form.comment_validated" )
                  div.el-input
                    el-upload(:disabled="formMode!='edit'" accept=".jpeg,.png,.jpg" :action="uploadForm.uploadUrl" :headers = "uploadForm.headers" :on-success="onUploadSuccess")
                      el-button(type="primary" icon="el-icon-upload" slot="trigger" :disabled="formMode!='edit'") 上传截图
                      el-button(v-if="form.comment_img" type="primary" icon="el-icon-thumb" @click="onViewCommentImg").ml-5 查看截图
                el-form-item(label="备注")
                  el-input(type="textarea" v-model="form.remark" :readonly="formMode!='edit'")
              //- 弹层
              el-dialog(:visible.sync="dialogImg" append-to-body width="50%")
                img(:src="form.comment_img" )
            el-tab-pane(label="访问日志" name="log")
              AcivityOrderLog(:aco_id="form.aco_id")
            el-tab-pane(label="问卷答案" name="survey")
              SurveyForm(:survey_string="form.survey")            


          div(slot="footer").dialog-footer
                el-button(@click="onUpdateCancel") 取消
                el-button(v-if="formMode=='edit' && activeTab=='form'" v-permission="['order:activity-order:edit']" :loading="form.loading" @click="onUpdateSave" type="primary") 保存

          //- 弹出层
        view-amazon-order(:odr_id.sync="current_odr_id")
</template>

<script>
import * as order from "../../api/order";
import { parseTime } from "../../utils";
import AppConfig from "../../app-config";
import { formatDateAndTime } from "../../filters";
import * as sku from "../../api/sku";
import ViewAmazonOrder from "./components/view-amazon-order";
import Tag from "./components/tag";
import Tags from "./components/tags";
import SurveyForm from "./components/survey-form";
import AcivityOrderLog from "./components/activity-order-log";
import Pagination from "@/components/pagination"; // Secondary package based on el-pagination
import _ from "lodash";
import { getStoreOptions } from "../../api/store";

export default {
  name: "activity-order-list",
  components: {
    Pagination,
    ViewAmazonOrder,
    Tag,
    Tags,
    AcivityOrderLog,
    SurveyForm
  },
  data() {
    return {
      storeOptions: [],
      activeTab: "form",
      formatDateAndTime,
      ...AppConfig.options,
      list: null,
      total: 0,
      listLoading: true,
      downloadLoading: false,
      uploadForm: {
        loading: false,
        rtn: null,
        hasFile: false,
        headers: sku.getExtraHeaders(),
        uploadUrl: sku.getUploadImgUrl(),
        filelist: []
      },
      listQuery: {
        page: 1,
        limit: 20,
        keyword: undefined,
        date: undefined,
        sort: "creation_date",
        order: "desc"
      },
      dialogForm: false,
      dialogImg: false,
      form: {},
      formMode: "edit",
      formRules: {
        comment_img: [
          {
            required: true,
            message: "请上传截图",
            trigger: "change"
          }
        ],
        tracking_no: [
          {
            required: true,
            message: "请填写礼品快递单号/Giftcard序列号",
            trigger: "change"
          }
        ],
        shipment_date: [
          {
            required: true,
            message: "请填写礼品发送时间",
            trigger: "change"
          }
        ]
      },
      current_odr_id: 0
    };
  },
  created() {
    this.getStoreOptions();
    this.getList();
  },
  computed: {
    lastUpdateBy() {
      return this.form.last_update_by
        ? `${this.form.last_update_by} @ ` +
            formatDateAndTime(this.form.last_update_date)
        : "";
    }
  },
  methods: {
    async getStoreOptions() {
      let resp = await getStoreOptions();
      this.storeOptions = resp.data.data;
    },
    async getList() {
      this.listLoading = true;
      try {
        const resp = await order.getActivityOrderList(this.listQuery);
        this.list = resp.data.data.items;
        this.total = resp.data.data.total;
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
      }
    },
    async onUpdate(row) {
      const res = await order.getActivityOrderByPK({ aco_id: row.aco_id });
      this.form = res.data.data;
      this.formMode = "edit";
      this.dialogForm = true;
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    onViewCommentImg() {
      this.dialogImg = true;
    },
    async onView(row) {
      const res = await order.getActivityOrderByPK({ aco_id: row.aco_id });
      this.form = res.data.data;
      this.formMode = "view";
      this.dialogForm = true;
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    onUploadSuccess(res) {
      this.form.comment_img = res.data.url;
    },
    async onUpdateCancel() {
      this.dialogForm = false;
    },
    async onUpdateSave() {
      try {
        await this.$refs.form.validate();
        const res = await order.updateActivityOrderByPK(this.form);
        if (res.data.errno == 200) {
          // 提示操作成功
          this.$notify.success({
            title: "成功",
            message: `订单:${this.form.order_id} 信息修改成功`
          });
          this.dialogForm = false;
          this.getList();
        }
      } catch (error) {
        return false;
      }
    },
    async onDelete(row) {
      try {
        // 询问是否进行
        await this.$confirm(
          "此操作将删除订单:" + row.order_id + ", 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );

        // 执行操作
        const res = await order.deleteActivityOrderByPK(row);

        if (res.data.errno == 200) {
          // 提示操作成功
          this.$notify.success({
            title: "成功",
            message: `订单:${row.order_id} 信息删除成功`
          });
        }
        this.getList();
      } catch (e) {
        return false;
      }
    },
    onViewAmazonOrder(row) {
      this.current_odr_id = row.odr_id;
    },
    onFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    translateOrderStatus(value) {
      const lbl = this.order_status_options.find(e => e.value == value);
      return (lbl && lbl.label) || value;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j.indexOf("_date") > -1) {
            return (v[j] && parseTime(v[j])) || "";
          } else if (j == "status") {
            const lbl = AppConfig.options.order_status_options.find(
              e => e.value == v[j]
            );
            return (lbl && lbl.label) || "";
          } else if (j == "comment_validated") {
            return v[j] ? "是" : "否";
          } else {
            return v[j];
          }
        })
      );
    },
    async onExport() {
      this.downloadLoading = true;
      const critria = _.assign(this.listQuery, { limit: 10000, page: 1 });
      const resp = await order.exportActivityOrderList(critria);
      const list = resp.data.data.items;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ASIN",
          "SKU",
          "店铺名称",
          "订单ID",
          "邮箱",
          "购买时间",
          "激活时间",
          "购买价格",
          "姓名",
          "电话",
          "地址",
          "备注",
          "活动名称",
          "活动类型",
          "Giftcard邮箱",
          "礼品名称",
          "礼品单收件人",
          "礼品单地址",
          "礼品单电话",
          "礼品运单号",
          "礼品发送时间",
          "Paypal Account",
          "Paypal Holder",
          "状态",
          "客户留评确认",
          "留评核实",
          "评论星级",
          "评论内容",
          "激活进度",
          "备注"
        ];
        const filterVal = [
          "asin",
          "sku",
          "store_name",
          "order_id",
          "email",
          "purchase_date",
          "active_date",
          "item_price_per_unit",
          "name",
          "phone",
          "address",
          "remark",
          "activity_name",
          "activity_type",
          "gift_name",
          "gift_email",
          "full_name",
          "address",
          "phone",
          "tracking_no",
          "shipment_date",
          "paypal_account",
          "paypal_holder",
          "status",
          "comment_confirmed",
          "comment_validated",
          "rating",
          "comment",
          "tags",
          "remark"
        ];

        list.map(e => {
          e.comment_confirmed = e.tags.indexOf("确认留评") > 1 ? "是" : "否";
        });
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            "邀评活动激活订单_" +
            parseTime(new Date(), "{y}-{m}-{d}_{h}:{i}:{s}"),
          autoWidth: true,
          bookType: "xlsx"
        });
        this.downloadLoading = false;
      });
    }
  }
};
</script>
